import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { ParticipantPage } from "./participant-page";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
const routes: Routes = [
    { path: '', loadComponent: () =>
      import('./participant-page').then(m => m.ParticipantPage)
    }
  ];
@NgModule({
    declarations: [
      ParticipantPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        SharedModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
      ParticipantPage
    ]
  })
  export class ParticipantModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }